import { render, staticRenderFns } from "./novaLog.vue?vue&type=template&id=1fc636b8"
import script from "./novaLog.vue?vue&type=script&lang=js"
export * from "./novaLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports